/**
 * GLOBAL CONSTANTS
 */
export const screenKeys = {
  foodcourt: 'foodcourt',
  kiosk: 'kiosk',
  restaurant: 'restaurant',
  facilities: 'facilities',
  shop: 'shop',
  event: 'event',
  promotion: 'promotion',
  config: 'config'
};

export const floorCode = {
  0: 'Tầng hầm',
  1: '1F',
  2: '2F',
  3: '3F',
  4: 'Tầng thượng và tầng hầm'
};

export const mapRouterType = {
  overview: 'overview',
  pathGuide: 'pathGuide'
};

export const deviceSvgId = 'deviceSvgId';
export const deviceFloorLevel = 'deviceFloorLevel';
export const mapOrientation = 'mapOrientation';
export const nearestElevator = 'nearestElevator';
export const touchDevices = 'touchDevices';

export const screenSaverTime = "screenSaverTime";
export const initScreen = "initScreen";

export const facility = {
  elevators: 'elevators',
  escalators: 'escalators',
  toilets: 'toilets',
  atms: 'atms',
  restArea: 'restArea',
  chargeArea: 'chargeArea',
  lockers: 'lockers',
  babyCare: 'babyCare',
  smokeArea: 'smokeArea',
  infoStall: 'infoStall',
  taxi: 'taxi'
};

/*  
NOTE: Page View GA is differrent to react-router routes in app since GA have to analyze different shop catalog, and detail title which have to call from api 
[location]: location that will reported in GA
[appPathname]: current pathname in app by react-router  
*/
export const gaSettings = {
  kiosk: {
    title: "Kiosk_Home",
    location: "/kiosk",
    appPathname: "/kiosk",
  },
  kioskShop: {
    title: "Kiosk_Shop",
    location: "/kiosk/shop",
    appPathname: "/kiosk/shop",
  },
  fashion: {
    title: "Kiosk_Shop/Category/Fashion & Accessories",
    location: "/kiosk/shop/category/fashion_accessories",
    appPathname: "/kiosk/shop",
  },
  food: {
    title: "Kiosk_Shop/Category/Food & Beverage",
    location: "/kiosk/shop/category/food_beverage",
    appPathname: "/kiosk/shop",
  },
  service: {
    title: "Kiosk_Shop/Category/Service, Entertainment & Specific Stores",
    location: "/kiosk/shop/category/service_entertainment_specific_stores",
    appPathname: "/kiosk/shop",
  },
  unknown: {
    title: "Kiosk_Shop/Category/Unknown",
    location: "/kiosk/shop/unknown",
    appPathname: "/kiosk/shop",
  },
  kioskShopDetail: {
    title: "Kiosk_Shop/Detail",
    location: "/kiosk/shop/detail?q=",
    appPathname: "/kiosk/shop",
  },
  facilities: {
    title: "Kiosk_Facilities",
    location: "/kiosk/facilities",
    appPathname: "/kiosk/facilities",
  },
  facilitiesDetail: {
    title: "Kiosk_Facilities/Detail",
    location: "/kiosk/facilities/detail?q=",
    appPathname: "/kiosk/facilities",
  },
  event: {
    title: "Kiosk_Event",
    location: "/kiosk/event",
    appPathname: "/kiosk/event",
  },
  eventDetail: {
    title: "Kiosk_Event/Detail",
    location: "/kiosk/event/detail?q=",
    appPathname: "/kiosk/event",
  },
  eventDirect: {
    title: "Kiosk_Event/Direct",
    location: "/kiosk/event/direct?q=",
    appPathname: "/kiosk/event",
  },
  promotion: {
    title: "Kiosk_Promotion",
    location: "/kiosk/promotion",
    appPathname: "/kiosk/promotion",
  },
  promotionDetail: {
    title: "Kiosk_Promotion/Detail",
    location: "/kiosk/promotion/detail?q=",
    appPathname: "/kiosk/promotion",
  },
  promotionDirect: {
    title: "Kiosk_Promotion/Direct",
    location: "/kiosk/promotion/direct?q=",
    appPathname: "/kiosk/promotion",
  },
  foodcourt: {
    title: "FoodCoast_Home",
    location: "/foodcoast",
    appPathname: "/foodcourt",
  },
  foodcourtDetail: {
    title: "FoodCoast_Detail",
    location: "/foodcoast/detail?q=",
    appPathname: "/foodcourt/",
  },
  restaurant: {
    title: "Restaurant_Home",
    location: "/restaurant",
    appPathname: "/restaurant",
  },
  restaurantDetail: {
    title: "Restaurant_Detail",
    location: "/restaurant/detail?q=",
    appPathname: "/restaurant/",
  },
};

export const gaSearch = {
  kiosk: {
    title: "Kiosk_Home/Search",
    location: "/kiosk/shop/search?q=",
    appPathname: "/kiosk",
  },
  kioskShop: {
    title: "Kiosk_Home/Search",
    location: "/kiosk/shop/search?q=",
    appPathname: "/kiosk/shop",
  },
  fashion: {
    title: "Kiosk_Shop/Category/Fashion & Accessories/Search",
    location: "/kiosk/shop/category/fashion_accessories/search?q=",
    appPathname: "/kiosk/shop",
  },
  food: {
    title: "Kiosk_Shop/Category/Food & Beverage/Search",
    location: "/kiosk/shop/category/food_beverage/search?q=",
    appPathname: "/kiosk/shop",
  },
  service: {
    title: "Kiosk_Shop/Category/Service, Entertainment & Specific Stores/Search",
    location: "/kiosk/shop/category/service_entertainment_specific_stores/search?q=",
    appPathname: "/kiosk/shop",
  },
  event: {
    title: "Kiosk_Event/Search",
    location: "/kiosk/event/search?q=",
    appPathname: "/kiosk/event",
  },
  promotion: {
    title: "Kiosk_Promotion/Search",
    location: "/kiosk/promotion/search?q=",
    appPathname: "/kiosk/promotion",
  },
  foodcourt: {
    title: "FoodCoast_Search",
    location: "/foodcoast/search?q=",
    appPathname: "/foodcourt",
  },
};

export const mapCatIdToKioskType = {
  871: "fashion",
  873: "fashion",
  875: "food",
  877: "food",
  879: "service",
  881: "service",
};

export const logoRectSize = 100;
export const mapRealLifeRatio = 15;
export const walkingSpeed = 88.66; // meter/minute


export const allEntrancesId = [202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212];
export const allHallsId = [213, 214, 215, 216, 217]